import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=6ec215f4&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=js"
export * from "./SimpleButton.vue?vue&type=script&lang=js"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=6ec215f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec215f4",
  null
  
)

export default component.exports